import React from 'react';
import { Grid } from '@mui/material';
import { useContext } from 'react';
import { CompanyContext } from '../../../../../../../context/CompanyContext';
import { CustomFieldEntityType } from '../../../../../../../types/custom_field/customField';
import { ContactContext } from '../../../../../../../context/ContactContext';
import { CustomFieldContext } from '../../../../../../../context/CustomFieldContext';
import { OrderInput, OrderUtil } from '../../../../../../../types/order/';
import { FlowType } from '../../../../../../../types/order/orderFlow';

interface CreateOrderFieldsViewProps {
  order: OrderInput;
  setOrder: (order: OrderInput) => void;
}

export default function CreateOrderFieldsView({ order, setOrder }: CreateOrderFieldsViewProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { contacts } = useContext(ContactContext);
  const { customFields } = useContext(CustomFieldContext);

  const orderFeatureToggles = currentCompany.settings.featureToggles.orders;
  const showContact =
    (currentCompany.settings.featureToggles.orders.customer && order.type === FlowType.outbound) ||
    (currentCompany.settings.featureToggles.orders.supplier && order.type === FlowType.inbound);

  return (
    <>
      {[...customFields.values()].filter(
        v =>
          !v.generated &&
          !v.hidden &&
          v.onCreate &&
          v.entityType === CustomFieldEntityType.order &&
          v.entitySubtype === OrderUtil.typeToEntitySubType(order.type),
      ).length ? (
        <>
          <Grid item xs={12}></Grid>
        </>
      ) : null}
    </>
  );
}
